const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

export async function createPhonePePayment(courseId) {
  const token = localStorage.getItem('cd_user_token');
  if (!token) {
    throw new Error('Please login before purchasing a course.');
  }

  const params = new URLSearchParams({ courseId: String(courseId) });
  const response = await fetch(`${API_BASE_URL}/payments/create?${params}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json().catch(() => null);
  if (!response.ok || !data?.success) {
    const error = new Error(data?.message || data?.success || 'Unable to start PhonePe checkout.');
    error.status = response.status;
    throw error;
  }

  if (Number(data.course?.id) !== Number(courseId)) {
    throw new Error('Payment response does not match the selected course.');
  }

  let paymentUrl;
  try {
    paymentUrl = new URL(data.paymentUrl);
  } catch {
    throw new Error('PhonePe returned an invalid payment URL.');
  }

  if (paymentUrl.protocol !== 'https:') {
    throw new Error('PhonePe returned an insecure payment URL.');
  }

  return data;
}

export async function purchaseCourse(courseId) {
  const token = localStorage.getItem('cd_user_token');
  if (!token) {
    throw new Error('Please login before purchasing a course.');
  }

  const response = await fetch(`${API_BASE_URL}/orders/purchase`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ courseId }),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.status === false) {
    throw new Error(data.message || 'Unable to purchase this course.');
  }

  return data;
}

export async function getMyOrders() {
  const token = localStorage.getItem('cd_user_token');
  if (!token) throw new Error('Please login to view your orders.');

  const response = await fetch(`${API_BASE_URL}/orders/my-orders`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.status === false) {
    throw new Error(data.message || 'Unable to load your orders.');
  }
  return data.orders || [];
}